export default function react(Element, statefull) {
    Element.kompo.statefulls.push(statefull);
}
//# sourceMappingURL=react.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/component/react.js
// module id = 13
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11